export default {
    primary: "#121D33",
    btnPrimary: "#EE1A26",
    darkBlue: "#1F2450",
    primaryLight: "#1F2450",
    grey: "#8A8FA7",
    white: "#fff",
    socialGreyDark: "#707070",
    menuCrossBackground: "#3a4255",
    
}